import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { getDifficulty } from '../../../redux/Settings/selectors';
import {
  getPhaseGoalsForCurrentPhase,
  getGameDifficulty,
} from '../../../redux/Game/selectors';
import { getRulesForCurrentPhase } from '../../../redux/Rules/selectors';
import Title from '../../baseComponents/Title';
import BaseButton from '../../baseButton';
import { SettingsActions } from '../../../redux/Settings';
import colors from '../../../utils/colors';

const Container = styled.div`
  z-index: 2;
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-content: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const Modal = styled.div`
  align-self: center;
  position: relative;
  padding-bottom: 24px;
  width: 60%;
  max-width: 650px;
  border: 2px solid ${colors.grey[3]};
  border-radius: 8px;
  background-color: ${colors.grey[1]};
  align-content: center;
  justify-content: center;
  text-align: center;
  color: ${colors.primaryText};
`;

const Change = styled.p`
  font-size: 22px;
`;

const SmallTitle = styled.h4`
  font-size: 16px;
  margin-top: 30px;
`;

const PhaseText = styled.p`
  margin: 30px auto 10px auto;
  font-size: 12px;
  width: 250px;
  color: ${colors.secondaryText};
`;

const Space = styled.p`
  height: 70px;
`;

const PhaseModal = () => {
  const dispatch = useDispatch();
  const goals = useSelector((state) => getPhaseGoalsForCurrentPhase(state));
  const rules = useSelector((state) => getRulesForCurrentPhase(state));
  const gameDifficulty = useSelector((state) => getGameDifficulty(state));
  const difficulty = useSelector((state) => getDifficulty(state));
  const { currentPhase } = useSelector((state) => state.settings);
  const phaseText = 'Phase ' + currentPhase;
  let phaseGoals = [];
  phaseGoals = goals.map((goal) => {
    return <Change key={goal.id}>{goal.displayName}</Change>;
  });

  let newRules = [];
  newRules = rules.map((rule) => {
    return <Change key={rule.id}>{rule.ruleString}</Change>;
  });

  const restartGame = () => {
    dispatch(SettingsActions.setShowPhaseModal(false));
    dispatch(SettingsActions.restartGame());
  };

  return (
    <Container>
      {currentPhase < 9 ? (
        <Modal>
          <Title text={phaseText} />
          <SmallTitle>
            Exit your current game and create new with difficulty:
          </SmallTitle>
          <Title text={gameDifficulty} />
          <SmallTitle>New rule:</SmallTitle>
          {newRules}
          <SmallTitle>New phase goals:</SmallTitle>
          {phaseGoals}
          <PhaseText>
            Phase goals are ment to be completed in order from top to bottom.
            All goals has to be completed before last phase goal is met.
          </PhaseText>
          <BaseButton
            size="18"
            text="Continue"
            onClick={() => dispatch(SettingsActions.setShowPhaseModal(false))}
          />
        </Modal>
      ) : (
        <Modal>
          <Title text="Concratulations!" />
          <SmallTitle>You have completed the game on {difficulty}!</SmallTitle>
          <SmallTitle>
            Now it&apos;s time to ramp up the difficulty or play with different
            class
          </SmallTitle>
          <Space />
          <BaseButton size="18" text="Start new game" onClick={restartGame} />
        </Modal>
      )}
    </Container>
  );
};

export default PhaseModal;
